const PAGE_WIDTH = 300;
const PAGE_HEIGHT = PAGE_WIDTH * 1.4;
const SIDE_MARGIN = 16;
const LINE_HEIGHT = 14;

class GiftCardMessageEditor {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.addEditButtonsToGiftCards();
    });
  }

  addEditButtonsToGiftCards() {
    const cartItems = document.querySelectorAll('.cart-item-container');
    
    cartItems.forEach(item => {
      let isGiftCard = false;
      let lineItemKey = '';
      let messageText = '';
      let currentPdfCode = '';
      let giftCardImageUrl = null;
      let messageNode = null;
      let hasIsGiftCardProperty = false;
      
      const propertiesContainer = item.querySelector('.description');
      if (!propertiesContainer) return;
      
      // First check for the new message structure with span.cart-message-property
      const messageProperty = propertiesContainer.querySelector('.cart-message-property');
      if (messageProperty) {
        messageNode = messageProperty;
        // Get the full message from data attribute (including line breaks)
        if (messageProperty.dataset.fullMessage) {
          messageText = messageProperty.dataset.fullMessage;
        } else {
          // Fallback to displayed text
          const messageDisplay = messageProperty.querySelector('.message-display');
          if (messageDisplay) {
            messageText = messageDisplay.textContent;
          }
        }
      }
      
      // If the new structure is not found, fall back to the old method
      if (!messageNode) {
        const textNodes = [];
        const walker = document.createTreeWalker(propertiesContainer, NodeFilter.SHOW_TEXT);
        let node;
        while (node = walker.nextNode()) {
          textNodes.push(node);
        }
        
        textNodes.forEach(node => {
          const text = node.textContent.trim();
          
          if (text.includes('Card Number:')) {
            isGiftCard = true;
            const cardNumberMatch = text.match(/Card Number:\s*([^\s]+)/);
            if (cardNumberMatch && cardNumberMatch[1]) {
              currentPdfCode = cardNumberMatch[1];
            }
          }
          
          if (text.includes('Message:')) {
            messageNode = node;
            const messageMatch = text.match(/Message:\s*(.*)/);
            if (messageMatch && messageMatch[1]) {
              messageText = messageMatch[1];
            }
          }
        });
      } else {
        // For the new structure, we still need to check if it's a gift card
        const textNodes = [];
        const walker = document.createTreeWalker(propertiesContainer, NodeFilter.SHOW_TEXT);
        let node;
        while (node = walker.nextNode()) {
          textNodes.push(node);
        }
        
        textNodes.forEach(node => {
          const text = node.textContent.trim();
          
          if (text.includes('Card Number:')) {
            isGiftCard = true;
            const cardNumberMatch = text.match(/Card Number:\s*([^\s]+)/);
            if (cardNumberMatch && cardNumberMatch[1]) {
              currentPdfCode = cardNumberMatch[1];
            }
          }
        });
      }
      
      const quantityInput = item.querySelector('input[name="updates[]"]');
      if (quantityInput) {
        lineItemKey = quantityInput.getAttribute('data-line');
      }
      
      if (typeof cartData !== 'undefined' && cartData.items) {
        const cartItemIndex = parseInt(lineItemKey) - 1; // Adjust for 0-based index
        if (cartItemIndex >= 0 && cartItemIndex < cartData.items.length) {
          const cartItem = cartData.items[cartItemIndex];
          if (cartItem && cartItem.properties) {
            hasIsGiftCardProperty = cartItem.properties._is_gift_card === 'true';
            giftCardImageUrl = cartItem.properties._gift_card_image_url || null;
          }
        }
      }
      
      if (isGiftCard && messageNode && hasIsGiftCardProperty) {
        const editButton = document.createElement('button');
        editButton.innerHTML = `Edit message`;
        editButton.className = 'edit-gift-message-btn';
        editButton.style.marginLeft = '6px';
        editButton.style.padding = '3px 6px';
        editButton.style.fontSize = '12px';
        editButton.style.border = '1px solid #ddd';
        editButton.style.borderRadius = '3px';
        editButton.style.background = 'transparent';
        editButton.style.color = '#000';
        editButton.style.cursor = 'pointer';
        editButton.style.verticalAlign = 'middle';
        editButton.style.display = 'inline-flex';
        editButton.style.alignItems = 'center';
        editButton.style.justifyContent = 'center';
        editButton.title = 'Edit Message';
        editButton.style.minWidth = 'auto';
        editButton.style.minHeight = 'auto';
        
        // For the new structure, append to the end of the message property span
        if (messageNode.classList && messageNode.classList.contains('cart-message-property')) {
          messageNode.appendChild(editButton);
        } else {
          // For the old structure
          messageNode.parentNode.insertBefore(editButton, messageNode.nextSibling);
        }
        
        editButton.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.showEditMessageModal(lineItemKey, messageText, currentPdfCode, giftCardImageUrl);
        });
      }
    });
  }

  showEditMessageModal(lineItemKey, currentMessage, currentPdfCode, giftCardImageUrl) {
    const modalOverlay = document.createElement('div');
    modalOverlay.className = 'edit-message-modal-overlay';
    modalOverlay.style.position = 'fixed';
    modalOverlay.style.top = '0';
    modalOverlay.style.left = '0';
    modalOverlay.style.width = '100%';
    modalOverlay.style.height = '100%';
    modalOverlay.style.backgroundColor = 'rgba(0,0,0,0.62)';
    modalOverlay.style.display = 'flex';
    modalOverlay.style.justifyContent = 'center';
    modalOverlay.style.alignItems = 'center';
    modalOverlay.style.zIndex = '1000001';
    
    let properMessageText = currentMessage;
    if (typeof cartData !== 'undefined' && cartData.items) {
      const cartItemIndex = parseInt(lineItemKey) - 1;
      if (cartItemIndex >= 0 && cartItemIndex < cartData.items.length) {
        const cartItem = cartData.items[cartItemIndex];
        if (cartItem && cartItem.properties && cartItem.properties.Message) {
          // Use the actual message from properties
          properMessageText = cartItem.properties.Message;
        }
      }
    }

    const formattedMessage = properMessageText.replace(/\n/g, '<br>');
    
    const modalContent = document.createElement('div');
    modalContent.className = 'edit-message-modal';
    modalContent.style.background = 'white';
    modalContent.style.padding = '40px';
    modalContent.style.borderRadius = '8px';
    modalContent.style.maxWidth = '800px';
    modalContent.style.width = '90%';
    modalContent.style.position = 'relative';
    modalContent.style.maxHeight = '90vh';
    modalContent.style.overflowY = 'auto';
    
    const closeButton = document.createElement('button');
    closeButton.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`;
    closeButton.className = 'close-button';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '15px';
    closeButton.style.right = '15px';
    closeButton.style.border = 'none';
    closeButton.style.background = 'none';
    closeButton.style.cursor = 'pointer';
    closeButton.style.display = 'flex';
    closeButton.style.padding = '0';
    closeButton.style.margin = '0';
    closeButton.style.color = '#000';
    closeButton.style.zIndex = '5';
    closeButton.style.minWidth = 'auto';
    closeButton.style.minHeight = 'auto';
    
    const formContent = `
      <h3>Edit Message</h3>
      <div class="row js message-preview-container">
        <div class="option-selector">
          <div class="form-group">
            <label for="edit_option_message">Message</label>
            <div class="message-preview" style="
              background: #FFFFFF;
              border: 1px solid #E5E5E5;
              border-radius: 4px;
              width: ${PAGE_WIDTH}px;
              height: ${PAGE_HEIGHT}px;
              margin: 0 auto;
              position: relative;
              display: flex;
              align-items: center;
              justify-content: center;">
              <div 
                class="editable-content" 
                contenteditable="true"
                data-placeholder="Type your message here..."
                data-max-length="450"
                style="
                  width: 100%;
                  height: auto;
                  max-height: 100%;
                  padding: ${SIDE_MARGIN}px;
                  font-family: 'Karla', sans-serif;
                  font-size: 16px !important;
                  line-height: ${LINE_HEIGHT}px;
                  text-align: center;
                  white-space: pre-wrap;
                  word-break: break-word;
                  outline: none;
                  overflow-y: auto;
                  position: relative;
                  -webkit-text-size-adjust: 100%;
                  text-size-adjust: 100%;
                  transform: scale(1);
                  transform-origin: top left;">${formattedMessage}</div>
              <input type="hidden" 
                class="message-input"
                id="edit_option_message"
                name="properties[Message]">
            </div>
            <div class="character-count" style="
              text-align: right;
              font-size: 12px;
              color: #666;
              margin-top: 4px;">
              <span class="current">0</span> of 450 characters
            </div>
          </div>
        </div>
      </div>
      <button type="button" class="update-message-button" style="
        background: #000;
        color: white;
        padding: 10px 20px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        width: 100%;
        font-size: 14px;
        text-transform: uppercase;
        margin-top: 20px;">Update Message</button>
    `;
    
    modalContent.innerHTML = formContent;
    modalContent.prepend(closeButton);
    
    modalOverlay.appendChild(modalContent);
    document.body.appendChild(modalOverlay);
    
    const editableContent = modalContent.querySelector('.editable-content');
    const hiddenInput = modalContent.querySelector('.message-input');
    const characterCount = modalContent.querySelector('.character-count .current');
    const updateButton = modalContent.querySelector('.update-message-button');
    
    characterCount.textContent = editableContent.textContent.length;
    
    editableContent.addEventListener('input', function() {
      const text = this.textContent;
      const maxLength = parseInt(this.dataset.maxLength);
      
      if (text.length > maxLength) {
        this.textContent = text.substring(0, maxLength);
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(this);
        range.collapse(false);
        sel.removeAllRanges();
        sel.addRange(range);
        characterCount.textContent = maxLength;
      } else {
        characterCount.textContent = text.length;
      }
      
      hiddenInput.value = this.innerHTML;
    });
    
    closeButton.addEventListener('click', function() {
      document.body.removeChild(modalOverlay);
    });
    
    updateButton.addEventListener('click', function() {
      this.textContent = 'Updating...';
      this.disabled = true;
      
      editableContent.setAttribute('contenteditable', 'false');
      editableContent.style.opacity = '0.7';
      editableContent.style.cursor = 'not-allowed';
      
      const processingOverlay = document.createElement('div');
      processingOverlay.className = 'edit-message-processing-overlay';
      processingOverlay.style.position = 'absolute';
      processingOverlay.style.top = '0';
      processingOverlay.style.left = '0';
      processingOverlay.style.width = '100%';
      processingOverlay.style.height = '100%';
      processingOverlay.style.backgroundColor = 'rgba(255,255,255,0.6)';
      processingOverlay.style.zIndex = '10';
      processingOverlay.style.display = 'flex';
      processingOverlay.style.justifyContent = 'center';
      processingOverlay.style.alignItems = 'center';
      
      const loadingIndicator = document.createElement('div');
      loadingIndicator.className = 'loading-indicator';
      loadingIndicator.style.width = '40px';
      loadingIndicator.style.height = '40px';
      loadingIndicator.style.border = '3px solid rgba(0,0,0,0.1)';
      loadingIndicator.style.borderTop = '3px solid #000';
      loadingIndicator.style.borderRadius = '50%';
      loadingIndicator.style.animation = 'spin 1s linear infinite';
      
      const styleSheet = document.createElement('style');
      styleSheet.innerHTML = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(styleSheet);
      
      processingOverlay.appendChild(loadingIndicator);
      modalContent.appendChild(processingOverlay);
      
      let messageText = editableContent.textContent;
      
      const htmlContent = editableContent.innerHTML;
      
      const processedMessage = htmlContent
        .replace(/<div>/gi, '\n')
        .replace(/<\/div>/gi, '')
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/&nbsp;/gi, ' ')
        .replace(/<[^>]*>/g, '')
        .trim()
        .replace(/\n{3,}/g, '\n\n');
      
      const newPdfCode = Math.random().toString(36).substring(2, 15);
      const newPdfUrl = `https://print-manager-media.s3.eu-west-1.amazonaws.com/puppeteer/polotno-cgl/${newPdfCode}.pdf`;
      
      fetch('https://puppeteer.personify.tech/api/polotno2pdf-cgl', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          message: processedMessage,
          imageType: 'default',
          pdfCode: newPdfCode,
          imageUrl: giftCardImageUrl,
          returnUrl: true
        })
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`PDF generation failed with status: ${response.status}`);
        }
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: parseInt(lineItemKey),
            properties: {
              'Message': processedMessage,
              'Card Number': newPdfCode,
              'PDF Link': newPdfUrl,
              '_is_gift_card': 'true',
              '_gift_card_image_url': giftCardImageUrl
            }
          })
        });
      })
      .then(response => response.json())
      .then(data => {
        window.location.reload();
      })
      .catch(error => {
        console.error('Error updating message or generating PDF:', error);

        editableContent.setAttribute('contenteditable', 'true');
        editableContent.style.opacity = '1';
        editableContent.style.cursor = 'text';
        
        const processingOverlay = modalContent.querySelector('.edit-message-processing-overlay');
        if (processingOverlay) {
          modalContent.removeChild(processingOverlay);
        }

        fetch('https://chat.personify.tech/sendMessage', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            message_thread_id: "1348",
            text: `🚨 *PDF Rendering Error from Cart Edit*\n\n`
                + `Message: ${processedMessage.replace(/\n/g, '\\n')}\n`
                + `PDF Code: ${newPdfCode}\n`
                + `Image URL: ${giftCardImageUrl || 'None'}\n`
                + `⏰ Time: ${new Date().toLocaleString()}\n`
                + `🔍 Details: ${error.message || 'PDF generation failed'}`,
            parse_mode: "MarkdownV2"
          })
        }).catch(telegramError => {
          console.error('Error sending Telegram notification:', telegramError);
        });

        updateButton.textContent = 'Update Message';
        updateButton.disabled = false;
        alert('There was an error updating your message. Please try again.');
      });
    });
    
    setTimeout(() => {
      editableContent.focus();
      
      const range = document.createRange();
      const sel = window.getSelection();
      range.selectNodeContents(editableContent);
      range.collapse(false);
      sel.removeAllRanges();
      sel.addRange(range);
    }, 100);
  }
}

new GiftCardMessageEditor(); 